import React, { useState, useEffect } from 'react';
import { api } from '../api';

// Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬ Shared components Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬

function Btn({ children, onClick, variant='primary', size='md', disabled, style }) {
  const base = { border:'none', borderRadius:9, fontWeight:600,
    cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.5 : 1,
    transition:'all 0.15s', ...style };
  const sz  = size==='sm' ? { padding:'6px 14px', fontSize:12 } : { padding:'10px 20px', fontSize:13 };
  const col = variant==='primary'  ? { background:'#6366f1', color:'#fff' }
            : variant==='danger'   ? { background:'#fee2e2', color:'#dc2626' }
            : variant==='success'  ? { background:'#dcfce7', color:'#16a34a' }
            :                         { background:'#f1f5f9', color:'#374151' };
  return <button onClick={onClick} disabled={disabled} style={{...base,...sz,...col}}>{children}</button>;
}

function Card({ children, style, onClick, hoverable }) {
  const [hov, setHov] = useState(false);
  return (
    <div onClick={onClick}
      onMouseEnter={()=>hoverable&&setHov(true)}
      onMouseLeave={()=>hoverable&&setHov(false)}
      style={{ background:'#fff', borderRadius:14, border:'1px solid #f1f5f9',
        boxShadow: hov ? '0 4px 20px rgba(99,102,241,0.15)' : '0 1px 4px rgba(0,0,0,0.05)',
        padding:24, cursor: onClick ? 'pointer' : undefined,
        transition:'box-shadow 0.15s', ...style }}>
      {children}
    </div>
  );
}

function Badge({ label, color='#6366f1', bg='#eef2ff' }) {
  return (
    <span style={{ fontSize:10, fontWeight:700, padding:'3px 8px', borderRadius:10,
      background:bg, color, border:`1px solid ${color}22` }}>
      {label}
    </span>
  );
}

// Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬ Persona Card Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬

function PersonaCard({ persona, onSelect, onLicense, myLicenses }) {
  const isLicensed = persona.already_licensed ||
    myLicenses.some(l => l.persona_id === persona.id && l.status === 'active');

  return (
    <Card hoverable onClick={()=>onSelect(persona)}>
      <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', marginBottom:14 }}>
        <div style={{ display:'flex', alignItems:'center', gap:12 }}>
          <div style={{ width:48, height:48, borderRadius:'50%',
            background:'linear-gradient(135deg,#6366f1,#8b5cf6)',
            display:'flex', alignItems:'center', justifyContent:'center', fontSize:22 }}>Ã°Å¸Å½â„¢</div>
          <div>
            <div style={{ fontWeight:800, fontSize:15, color:'#0f172a' }}>{persona.voice_name}</div>
            <div style={{ fontSize:11, color:'#94a3b8' }}>{persona.voice_gender} Ã‚Â· {persona.energy_level} energy</div>
          </div>
        </div>
        {isLicensed && <Badge label="Licensed" color="#16a34a" bg="#f0fdf4" />}
      </div>

      {persona.personality_summary && (
        <div style={{ fontSize:12, color:'#64748b', lineHeight:1.6, marginBottom:12,
          display:'-webkit-box', WebkitLineClamp:2, WebkitBoxOrient:'vertical', overflow:'hidden' }}>
          {persona.personality_summary}
        </div>
      )}

      <div style={{ display:'flex', gap:6, flexWrap:'wrap', marginBottom:14 }}>
        <Badge label={persona.humor_style} />
        <Badge label={persona.pacing + ' pacing'} color="#0891b2" bg="#f0f9ff" />
        {persona.catchphrases_preview?.slice(0,1).map((c,i)=>(
          <Badge key={i} label={`"${c.slice(0,20)}${c.length>20?'Ã¢â‚¬Â¦':''}"` } color="#7c3aed" bg="#faf5ff" />
        ))}
      </div>

      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
        <div>
          {persona.license_price_monthly > 0 && (
            <span style={{ fontSize:18, fontWeight:800, color:'#0f172a' }}>
              ${persona.license_price_monthly}
              <span style={{ fontSize:11, fontWeight:400, color:'#94a3b8' }}>/mo</span>
            </span>
          )}
          {persona.license_price_monthly === 0 && (
            <span style={{ fontSize:14, fontWeight:700, color:'#16a34a' }}>Free</span>
          )}
        </div>
        <div style={{ display:'flex', gap:8 }}>
          {persona.sample_clip_url && (
            <Btn size='sm' variant='ghost'
              onClick={e=>{e.stopPropagation();window.open(persona.sample_clip_url,'_blank');}}>
              Ã¢â€“Â¶ Sample
            </Btn>
          )}
          {!isLicensed ? (
            <Btn size='sm' onClick={e=>{e.stopPropagation();onLicense(persona);}}>License</Btn>
          ) : (
            <Btn size='sm' variant='ghost' disabled>Licensed Ã¢Å“â€œ</Btn>
          )}
        </div>
      </div>

      {persona.active_licenses > 0 && (
        <div style={{ marginTop:10, fontSize:11, color:'#94a3b8' }}>
          {persona.active_licenses} active license{persona.active_licenses!==1?'s':''}
        </div>
      )}
    </Card>
  );
}

// Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬ License Modal Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬

function LicenseModal({ persona, onClose, onLicensed }) {
  const [usageType, setUsageType] = useState('monthly');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fee = usageType==='monthly' ? persona.license_price_monthly : persona.license_price_per_shift;

  const confirm = async () => {
    setLoading(true); setError(null);
    try {
      const res = await api.post(`/broadcast/marketplace/${persona.id}/license`, { usage_type: usageType });
      onLicensed(res);
    } catch(e) { setError(e.message); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)',
      display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }}>
      <div style={{ background:'#fff', borderRadius:16, width:480 }}>
        <div style={{ padding:'18px 24px', borderBottom:'1px solid #f1f5f9',
          display:'flex', alignItems:'center', justifyContent:'space-between' }}>
          <div style={{ fontWeight:700, color:'#0f172a' }}>License {persona.voice_name}</div>
          <Btn onClick={onClose} variant='ghost' size='sm'>Ã¢Å“â€¢</Btn>
        </div>
        <div style={{ padding:24 }}>
          <div style={{ fontSize:13, color:'#64748b', marginBottom:20, lineHeight:1.6 }}>
            {persona.marketplace_description || persona.personality_summary}
          </div>

          <div style={{ fontSize:12, fontWeight:600, color:'#374151', marginBottom:10 }}>License Type</div>
          <div style={{ display:'flex', gap:10, marginBottom:20 }}>
            {[
              { id:'monthly', label:'Monthly', price: persona.license_price_monthly, desc:'Unlimited use for 30 days' },
              { id:'per_shift', label:'Per Shift', price: persona.license_price_per_shift, desc:'Single broadcast shift' },
            ].filter(t => t.price > 0 || t.id==='monthly').map(t=>(
              <button key={t.id} onClick={()=>setUsageType(t.id)} style={{
                flex:1, padding:14, borderRadius:10, cursor:'pointer', textAlign:'left',
                border:`2px solid ${usageType===t.id ? '#6366f1' : '#e2e8f0'}`,
                background: usageType===t.id ? '#eef2ff' : '#fff' }}>
                <div style={{ fontWeight:700, fontSize:14, color: usageType===t.id ? '#6366f1' : '#0f172a' }}>
                  {t.price > 0 ? `$${t.price}` : 'Free'} <span style={{ fontSize:11, fontWeight:400 }}>{t.id==='monthly'?'/mo':'/shift'}</span>
                </div>
                <div style={{ fontSize:11, color:'#64748b', marginTop:3 }}>{t.label} Ã‚Â· {t.desc}</div>
              </button>
            ))}
          </div>

          <div style={{ background:'#f8fafc', borderRadius:10, padding:14, marginBottom:20 }}>
            <div style={{ fontSize:12, fontWeight:700, color:'#374151', marginBottom:8 }}>Revenue Split</div>
            {[
              { label:'Artist (persona owner)', pct: 70, color:'#6366f1' },
              { label:'Groovie Platform', pct: 20, color:'#0891b2' },
              { label:'VoiceSeal (IP protection)', pct: 10, color:'#7c3aed' },
            ].map(r=>(
              <div key={r.label} style={{ display:'flex', alignItems:'center', gap:10, marginBottom:8 }}>
                <div style={{ flex:1, fontSize:12, color:'#374151' }}>{r.label}</div>
                <div style={{ width:120, height:6, borderRadius:3, background:'#f1f5f9', overflow:'hidden' }}>
                  <div style={{ width:`${r.pct}%`, height:'100%', background:r.color, borderRadius:3 }} />
                </div>
                <div style={{ fontSize:12, fontWeight:700, color:r.color, width:32, textAlign:'right' }}>{r.pct}%</div>
              </div>
            ))}
          </div>

          {error && <div style={{ marginBottom:12, padding:10, background:'#fef2f2', borderRadius:8, fontSize:12, color:'#dc2626' }}>{error}</div>}

          <div style={{ display:'flex', gap:10 }}>
            <Btn onClick={onClose} variant='ghost' style={{ flex:1 }}>Cancel</Btn>
            <Btn onClick={confirm} disabled={loading} style={{ flex:2 }}>
              {loading ? 'ProcessingÃ¢â‚¬Â¦' : fee > 0 ? `License for $${fee}` : 'Activate Free License'}
            </Btn>
          </div>
        </div>
      </div>
    </div>
  );
}

// Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬ My Listings Panel Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬

function MyListings({ onRefresh }) {
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/broadcast/marketplace/my/listings')
      .then(r => setListings(r.listings||[]))
      .catch(()=>{})
      .finally(()=>setLoading(false));
  }, []);

  const startEdit = (listing) => {
    setEditing(listing.id);
    setEditForm({
      is_licensable: listing.is_licensable,
      license_price_monthly: listing.license_price_monthly || 0,
      license_price_per_shift: listing.license_price_per_shift || 0,
      marketplace_description: listing.marketplace_description || '',
    });
  };

  const save = async (personaId) => {
    setSaving(true);
    try {
      await api.put(`/broadcast/marketplace/my/listings/${personaId}`, editForm);
      setListings(prev => prev.map(l => l.id===personaId ? {...l,...editForm} : l));
      setEditing(null);
    } catch(e) {}
    finally { setSaving(false); }
  };

  if (loading) return <div style={{ textAlign:'center', padding:40, color:'#94a3b8' }}>LoadingÃ¢â‚¬Â¦</div>;

  if (listings.length === 0) return (
    <div style={{ textAlign:'center', padding:60, color:'#94a3b8' }}>
      <div style={{ fontSize:40, marginBottom:12 }}>Ã°Å¸Å½â„¢</div>
      <div style={{ fontSize:15, fontWeight:600, color:'#374151', marginBottom:8 }}>No personas ready to list</div>
      <div style={{ fontSize:13 }}>Voice clone must be complete before listing on marketplace.</div>
    </div>
  );

  return (
    <div style={{ display:'grid', gap:14 }}>
      {listings.map(l => (
        <Card key={l.id}>
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom: editing===l.id ? 16 : 0 }}>
            <div style={{ display:'flex', alignItems:'center', gap:12 }}>
              <div style={{ width:40, height:40, borderRadius:'50%', background:'linear-gradient(135deg,#6366f1,#8b5cf6)',
                display:'flex', alignItems:'center', justifyContent:'center', fontSize:18 }}>Ã°Å¸Å½â„¢</div>
              <div>
                <div style={{ fontWeight:700, color:'#0f172a' }}>{l.voice_name}</div>
                <div style={{ fontSize:12, color:'#64748b' }}>
                  {l.active_licenses} active license{l.active_licenses!==1?'s':''}
                  {l.monthly_revenue > 0 && ` Ã‚Â· $${Number(l.monthly_revenue).toFixed(2)}/mo revenue`}
                </div>
              </div>
            </div>
            <div style={{ display:'flex', alignItems:'center', gap:10 }}>
              <span style={{ fontSize:11, fontWeight:600, padding:'3px 10px', borderRadius:10,
                background: l.is_licensable ? '#f0fdf4' : '#f8fafc',
                color: l.is_licensable ? '#16a34a' : '#94a3b8',
                border:`1px solid ${l.is_licensable ? '#bbf7d0' : '#e2e8f0'}` }}>
                {l.is_licensable ? 'Listed' : 'Unlisted'}
              </span>
              <Btn size='sm' variant='ghost' onClick={()=>editing===l.id ? setEditing(null) : startEdit(l)}>
                {editing===l.id ? 'Cancel' : 'Edit'}
              </Btn>
            </div>
          </div>

          {editing===l.id && (
            <div style={{ borderTop:'1px solid #f1f5f9', paddingTop:16 }}>
              <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:14 }}>
                <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer' }}>
                  <div onClick={()=>setEditForm(p=>({...p,is_licensable:!p.is_licensable}))} style={{
                    width:40, height:22, borderRadius:11,
                    background: editForm.is_licensable ? '#6366f1' : '#e2e8f0',
                    position:'relative', cursor:'pointer', transition:'background 0.2s', flexShrink:0 }}>
                    <div style={{ position:'absolute', top:2, left: editForm.is_licensable ? 20 : 2,
                      width:18, height:18, borderRadius:'50%', background:'#fff',
                      transition:'left 0.2s', boxShadow:'0 1px 3px rgba(0,0,0,0.2)' }} />
                  </div>
                  <span style={{ fontSize:13, fontWeight:600 }}>List on Marketplace</span>
                </label>
              </div>

              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:12 }}>
                <div>
                  <div style={{ fontSize:12, fontWeight:600, color:'#374151', marginBottom:5 }}>Monthly Price ($)</div>
                  <input type="number" min="0" step="0.01"
                    value={editForm.license_price_monthly}
                    onChange={e=>setEditForm(p=>({...p,license_price_monthly:parseFloat(e.target.value)||0}))}
                    style={{ width:'100%', padding:'8px 10px', border:'1px solid #e2e8f0', borderRadius:8,
                      fontSize:13, boxSizing:'border-box' }} />
                </div>
                <div>
                  <div style={{ fontSize:12, fontWeight:600, color:'#374151', marginBottom:5 }}>Per-Shift Price ($)</div>
                  <input type="number" min="0" step="0.01"
                    value={editForm.license_price_per_shift}
                    onChange={e=>setEditForm(p=>({...p,license_price_per_shift:parseFloat(e.target.value)||0}))}
                    style={{ width:'100%', padding:'8px 10px', border:'1px solid #e2e8f0', borderRadius:8,
                      fontSize:13, boxSizing:'border-box' }} />
                </div>
              </div>

              <div style={{ marginBottom:14 }}>
                <div style={{ fontSize:12, fontWeight:600, color:'#374151', marginBottom:5 }}>Marketplace Description</div>
                <textarea value={editForm.marketplace_description}
                  onChange={e=>setEditForm(p=>({...p,marketplace_description:e.target.value}))}
                  rows={3} placeholder="Describe your persona for potential licenseesÃ¢â‚¬Â¦"
                  style={{ width:'100%', padding:'8px 10px', border:'1px solid #e2e8f0', borderRadius:8,
                    fontSize:13, fontFamily:'inherit', resize:'vertical', boxSizing:'border-box' }} />
              </div>

              <Btn onClick={()=>save(l.id)} disabled={saving} style={{ width:'100%' }}>
                {saving ? 'SavingÃ¢â‚¬Â¦' : 'Save Listing'}
              </Btn>
            </div>
          )}
        </Card>
      ))}
    </div>
  );
}

// Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬ Main Page Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬

export default function Marketplace() {
  const [tab, setTab] = useState('browse');
  const [listings, setListings] = useState([]);
  const [myLicenses, setMyLicenses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ gender:'', energy:'', search:'' });
  // eslint-disable-next-line no-unused-vars
  const [selectedPersona, setSelectedPersona] = useState(null);
  const [licensingPersona, setLicensingPersona] = useState(null);
  const [total, setTotal] = useState(0);
  const [duos, setDuos] = useState([]);
  const [duosLoading, setDuosLoading] = useState(false);

  const loadBrowse = () => {
    setLoading(true);
    const params = new URLSearchParams();
    if (filters.gender) params.set('gender', filters.gender);
    if (filters.energy) params.set('energy', filters.energy);
    if (filters.search) params.set('search', filters.search);
    params.set('limit', '20');

    Promise.all([
      api.get(`/broadcast/marketplace?${params}`),
      api.get('/broadcast/marketplace/my/licenses').catch(()=>({licenses:[]})),
    ]).then(([browse, lic]) => {
      setListings(browse.listings||[]);
      setTotal(browse.total||0);
      setMyLicenses(lic.licenses||[]);
    }).catch(()=>{})
    .finally(()=>setLoading(false));
  };

  useEffect(() => { if (tab==='browse') loadBrowse(); }, [tab, filters]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (tab==='duos') {
      setDuosLoading(true);
      api.get('/broadcast/marketplace/duos')
        .then(r => setDuos(r.duos||[]))
        .catch(()=>{})
        .finally(()=>setDuosLoading(false));
    }
  }, [tab]); // eslint-disable-line react-hooks/exhaustive-deps

  const tabStyle = (t) => ({
    padding:'9px 20px', fontSize:13, fontWeight:600, cursor:'pointer',
    border:'none', background:'transparent',
    borderBottom:`2px solid ${tab===t ? '#6366f1' : 'transparent'}`,
    color: tab===t ? '#6366f1' : '#64748b', transition:'all 0.15s'
  });

  return (
    <div style={{ maxWidth:1100, margin:'0 auto' }}>
      {/* Header */}
      <div style={{ marginBottom:28 }}>
        <h1 style={{ fontSize:24, fontWeight:800, color:'#0f172a', margin:0 }}>DBP Marketplace</h1>
        <p style={{ fontSize:13, color:'#64748b', margin:'4px 0 0' }}>
          License AI broadcast personas from other broadcasters Ã‚Â· 70/20/10 revenue split
        </p>
      </div>

      {/* Tabs */}
      <div style={{ display:'flex', borderBottom:'1px solid #f1f5f9', marginBottom:24 }}>
        <button style={tabStyle('browse')} onClick={()=>setTab('browse')}>Browse Personas</button>
        <button style={tabStyle('licenses')} onClick={()=>setTab('licenses')}>
          My Licenses {myLicenses.filter(l=>l.status==='active').length > 0 && `(${myLicenses.filter(l=>l.status==='active').length})`}
        </button>
        <button style={tabStyle('listings')} onClick={()=>setTab('listings')}>My Listings</button>
        <button style={tabStyle('duos')} onClick={()=>setTab('duos')}>🎙 Duo Pairs</button>
      </div>

      {tab==='browse' && (
        <>
          {/* Filters */}
          <div style={{ display:'flex', gap:10, marginBottom:20, flexWrap:'wrap' }}>
            <input value={filters.search} onChange={e=>setFilters(p=>({...p,search:e.target.value}))}
              placeholder="Search personasÃ¢â‚¬Â¦"
              style={{ flex:1, minWidth:200, padding:'9px 12px', border:'1px solid #e2e8f0',
                borderRadius:9, fontSize:13, outline:'none' }} />
            {[
              { key:'gender', options:['male','female','neutral'], label:'Gender' },
              { key:'energy', options:['high','medium','low'], label:'Energy' },
            ].map(f=>(
              <select key={f.key} value={filters[f.key]}
                onChange={e=>setFilters(p=>({...p,[f.key]:e.target.value}))}
                style={{ padding:'9px 12px', border:'1px solid #e2e8f0', borderRadius:9,
                  fontSize:13, background:'#fff', cursor:'pointer' }}>
                <option value="">All {f.label}</option>
                {f.options.map(o=><option key={o} value={o}>{o.charAt(0).toUpperCase()+o.slice(1)}</option>)}
              </select>
            ))}
          </div>

          {loading ? (
            <div style={{ textAlign:'center', padding:60, color:'#94a3b8' }}>Loading personasÃ¢â‚¬Â¦</div>
          ) : listings.length === 0 ? (
            <div style={{ textAlign:'center', padding:60 }}>
              <div style={{ fontSize:40, marginBottom:12 }}>Ã°Å¸Å½â„¢</div>
              <div style={{ fontSize:15, fontWeight:600, color:'#374151', marginBottom:8 }}>No personas available</div>
              <div style={{ fontSize:13, color:'#94a3b8' }}>Check back soon Ã¢â‚¬â€ broadcasters are building their personas.</div>
            </div>
          ) : (
            <>
              <div style={{ fontSize:12, color:'#94a3b8', marginBottom:16 }}>{total} persona{total!==1?'s':''}  available</div>
              <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(320px,1fr))', gap:16 }}>
                {listings.map(p=>(
                  <PersonaCard key={p.id} persona={p} myLicenses={myLicenses}
                    onSelect={setSelectedPersona}
                    onLicense={setLicensingPersona} />
                ))}
              </div>
            </>
          )}
        </>
      )}

      {tab==='licenses' && (
        <div>
          {myLicenses.length === 0 ? (
            <div style={{ textAlign:'center', padding:60 }}>
              <div style={{ fontSize:40, marginBottom:12 }}>Ã°Å¸â€œâ€¹</div>
              <div style={{ fontSize:15, fontWeight:600, color:'#374151', marginBottom:8 }}>No active licenses</div>
              <div style={{ fontSize:13, color:'#94a3b8', marginBottom:20 }}>Browse the marketplace to license a persona.</div>
              <Btn onClick={()=>setTab('browse')}>Browse Personas</Btn>
            </div>
          ) : (
            <div style={{ display:'grid', gap:14 }}>
              {myLicenses.map(l=>(
                <Card key={l.id}>
                  <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                    <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                      <div style={{ width:44, height:44, borderRadius:'50%',
                        background:'linear-gradient(135deg,#6366f1,#8b5cf6)',
                        display:'flex', alignItems:'center', justifyContent:'center', fontSize:20 }}>Ã°Å¸Å½â„¢</div>
                      <div>
                        <div style={{ fontWeight:700, color:'#0f172a' }}>{l.voice_name}</div>
                        <div style={{ fontSize:12, color:'#64748b' }}>
                          {l.usage_type} Ã‚Â· ${l.monthly_fee}
                          {l.days_remaining !== null && ` Ã‚Â· ${Math.max(0,Math.round(l.days_remaining))} days remaining`}
                        </div>
                      </div>
                    </div>
                    <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                      <span style={{ fontSize:11, fontWeight:600, padding:'3px 10px', borderRadius:10,
                        background: l.status==='active' ? '#f0fdf4' : '#fef2f2',
                        color: l.status==='active' ? '#16a34a' : '#dc2626' }}>
                        {l.status}
                      </span>
                      {l.status==='active' && (
                        <Btn size='sm' variant='danger'
                          onClick={()=>api.del(`/broadcast/marketplace/licenses/${l.id}`)
                            .then(()=>setMyLicenses(prev=>prev.map(x=>x.id===l.id?{...x,status:'cancelled'}:x)))
                            .catch(()=>{})}>
                          Cancel
                        </Btn>
                      )}
                    </div>
                  </div>
                  {!l.can_generate && l.status==='active' && (
                    <div style={{ marginTop:10, fontSize:11, color:'#92400e', background:'#fffbeb',
                      padding:'6px 10px', borderRadius:7 }}>
                      Ã¢Å¡Â Ã¯Â¸Â Voice clone not complete Ã¢â‚¬â€ contact persona owner
                    </div>
                  )}
                </Card>
              ))}
            </div>
          )}
        </div>
      )}

      {tab==='listings' && <MyListings />}

      {tab==='duos' && (
        <div>
          <div style={{ fontSize:13, color:'#64748b', marginBottom:20 }}>
            License two personas as a co-anchor pair and save 15% on the combined monthly rate.
          </div>
          {duosLoading ? (
            <div style={{ textAlign:'center', padding:60, color:'#94a3b8' }}>Loading duo pairs…</div>
          ) : duos.length === 0 ? (
            <div style={{ textAlign:'center', padding:60 }}>
              <div style={{ fontSize:40, marginBottom:12 }}>🎙🎙</div>
              <div style={{ fontSize:15, fontWeight:600, color:'#374151', marginBottom:8 }}>No duo pairs available yet</div>
              <div style={{ fontSize:13, color:'#94a3b8' }}>Broadcasters with multiple cloned personas will appear here.</div>
            </div>
          ) : (
            <div style={{ display:'grid', gap:16 }}>
              {duos.map((duo,i) => (
                <div key={i} style={{ background:'#fff', borderRadius:14, border:'1px solid #f1f5f9',
                  boxShadow:'0 1px 4px rgba(0,0,0,0.05)', padding:24 }}>
                  {/* Personas side by side */}
                  <div style={{ display:'grid', gridTemplateColumns:'1fr auto 1fr', gap:16, alignItems:'center', marginBottom:20 }}>
                    {[duo.persona_a, duo.persona_b].map((p,pi) => (
                      <div key={pi} style={{ background:'#f8fafc', borderRadius:10, padding:14, textAlign:'center' }}>
                        <div style={{ width:48, height:48, borderRadius:'50%', margin:'0 auto 10px',
                          background:'linear-gradient(135deg,#6366f1,#8b5cf6)',
                          display:'flex', alignItems:'center', justifyContent:'center', fontSize:22 }}>🎙</div>
                        <div style={{ fontWeight:800, fontSize:14, color:'#0f172a', marginBottom:2 }}>{p.voice_name}</div>
                        <div style={{ fontSize:11, color:'#94a3b8', marginBottom:8 }}>{p.voice_gender} · {p.energy_level}</div>
                        <div style={{ fontSize:13, fontWeight:700, color:'#0f172a' }}>${p.price_monthly}<span style={{ fontSize:10, fontWeight:400, color:'#94a3b8' }}>/mo</span></div>
                        {p.already_licensed && <div style={{ marginTop:6, fontSize:10, background:'#f0fdf4', color:'#16a34a', padding:'2px 8px', borderRadius:8, display:'inline-block', fontWeight:600 }}>Licensed ✓</div>}
                      </div>
                    ))}
                    <div style={{ textAlign:'center' }}>
                      <div style={{ fontSize:24, marginBottom:4 }}>🤝</div>
                      <div style={{ fontSize:11, fontWeight:700, color:'#6366f1' }}>CO-ANCHOR</div>
                      <div style={{ fontSize:10, color:'#94a3b8' }}>3 modes</div>
                    </div>
                  </div>
                  {/* Pricing */}
                  <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between',
                    background:'#f0fdf4', borderRadius:10, padding:'12px 16px', marginBottom:16 }}>
                    <div>
                      <div style={{ fontSize:12, color:'#166534', fontWeight:600 }}>Bundle Price</div>
                      <div style={{ fontSize:22, fontWeight:800, color:'#16a34a' }}>
                        ${duo.bundle_price}<span style={{ fontSize:12, fontWeight:400, color:'#4ade80' }}>/mo</span>
                      </div>
                    </div>
                    <div style={{ textAlign:'right' }}>
                      <div style={{ fontSize:11, color:'#94a3b8', textDecoration:'line-through' }}>${duo.combined_price} combined</div>
                      <div style={{ fontSize:12, fontWeight:700, color:'#16a34a' }}>Save ${duo.discount} (15% off)</div>
                    </div>
                  </div>
                  {/* Modes */}
                  <div style={{ display:'flex', gap:6, marginBottom:16 }}>
                    {duo.co_anchor_modes.map(m=>(
                      <span key={m} style={{ fontSize:10, fontWeight:600, padding:'3px 8px', borderRadius:8,
                        background:'#eef2ff', color:'#6366f1', border:'1px solid #c7d2fe' }}>
                        {m.replace(/_/g,' ')}
                      </span>
                    ))}
                  </div>
                  {/* Action */}
                  {duo.both_licensed ? (
                    <div style={{ textAlign:'center', fontSize:13, fontWeight:600, color:'#16a34a' }}>
                      ✅ Both personas licensed — ready for co-anchor shifts
                    </div>
                  ) : (
                    <div style={{ display:'flex', gap:10 }}>
                      {!duo.persona_a.already_licensed && (
                        <button onClick={()=>setLicensingPersona(duo.persona_a)} style={{
                          flex:1, padding:'10px 0', borderRadius:9, border:'none', cursor:'pointer',
                          background:'#6366f1', color:'#fff', fontWeight:600, fontSize:13 }}>
                          License {duo.persona_a.voice_name}
                        </button>
                      )}
                      {!duo.persona_b.already_licensed && (
                        <button onClick={()=>setLicensingPersona(duo.persona_b)} style={{
                          flex:1, padding:'10px 0', borderRadius:9, border:'none', cursor:'pointer',
                          background:'#6366f1', color:'#fff', fontWeight:600, fontSize:13 }}>
                          License {duo.persona_b.voice_name}
                        </button>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* License modal */}
      {licensingPersona && (
        <LicenseModal
          persona={licensingPersona}
          onClose={()=>setLicensingPersona(null)}
          onLicensed={(res)=>{
            setLicensingPersona(null);
            setMyLicenses(prev=>[...prev, {
              id: res.license_id, persona_id: licensingPersona.id,
              voice_name: licensingPersona.voice_name,
              usage_type: res.usage_type, monthly_fee: res.monthly_fee,
              status: 'active', days_remaining: 30,
              can_generate: licensingPersona.elevenlabs_clone_status==='ready'
            }]);
            setListings(prev=>prev.map(p=>p.id===licensingPersona.id?{...p,already_licensed:true}:p));
          }}
        />
      )}
    </div>
  );
}